import React from "react";
import moment from "moment/moment";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { TrashIcon } from "@heroicons/react/24/outline";
import Spinner from "../../../ui-components/Spinner";

const undefinedCell = (intl, key = "undefined") => (
  <>
    <span className="text-gray-400 whitespace-nowrap">
      {intl.formatMessage({ id: key })}
    </span>
  </>
);

const renderList = (intl, values) => {
  if (values === "") return null; // to be expanded
  if (!values || values.length === 0) return undefinedCell(intl, "undefined");
  return (
    <ul
      className={`list-inside whitespace-nowrap ${
        values.length > 1 ? "list-disc" : "list-none"
      }`}
    >
      {values.map((p, idx) => (
        <li key={idx}>{p}</li>
      ))}
    </ul>
  );
};

export const getColumns = (intl, countryCode, colors, setSurveyIdToDelete) => [
  {
    title: "", // row controls
    filtering: false,
    render: ({ id, service_id, parentId }) => {
      if (parentId) return null;
      return (
        <div className="flex gap-5">
          <a
            // target="_blank"
            rel="noopener noreferrer"
            href={`/${countryCode}/service/${service_id}/survey/${id}`}
          >
            <ArrowTopRightOnSquareIcon className="w-6 h-6 text-kerakoll-400 cursor-pointer" />
          </a>
          <TrashIcon
            className="w-6 h-6 text-kerakoll-400 cursor-pointer"
            onClick={() => {
              setSurveyIdToDelete(id);
            }}
          />
        </div>
      );
    },
  },
  {
    title: intl.formatMessage({ id: "name" }),
    field: "name",
    type: "string",
    headerStyle: { minWidth: 300 },
  },
  {
    title: intl.formatMessage({ id: "color" }),
    field: "color",
    type: "string",
    render: ({ color }) => {
      // CASE 1: colors are not loaded yet --> render a spinner
      if (!colors?.length)
        return (
          <div className="relative w-full h-10 text-center">
            <Spinner styleType="white"/>
          </div>
        );
      // CASE 2: parent row --> render "expand" label
      if (color === "")
        return (
          <span className="text-gray-300">
            {intl.formatMessage({ id: "expand" })}
          </span>
        );
      // CASE 3: no color --> render "undefined" label
      if (!color) return undefinedCell(intl);
      // CASE 4: color is defined --> render color block and code (black with "-" label if color is not found)
      const kccInfo = colors?.find((c) => c.code === color);
      return (
        <div className="flex items-center gap-3">
          <div
            className="w-5"
            style={{
              border: "1px solid #fff5",
              backgroundColor: `rgb(${(kccInfo?.rgb ?? [0, 0, 0]).join(", ")})`,
              aspectRatio: "1 / 1",
            }}
          />
          <span>{kccInfo?.code ?? "-"}</span>
        </div>
      );
    },
  },
  {
    title: intl.formatMessage({ id: "system" }),
    field: "system",
    type: "string",
    render: ({ system }) =>
      system !== "" ? system ?? undefinedCell(intl) : null,
  },
  ...["primers", "reti", "rasanti"].map((target) => ({
    title: intl.formatMessage({ id: target }),
    field: target,
    render: (row) => renderList(intl, row[target]),
  })),
  {
    title: intl.formatMessage({ id: "surface" }),
    field: "surface",
    type: "numeric",
    align: "left",
    render: ({ surface }) =>
      surface
        ? `${surface} mq`
        : surface !== ""
        ? undefinedCell(intl, "undefined_f")
        : null,
  },
  {
    title: intl.formatMessage({ id: "closed_f" }),
    field: "closed",
    type: "boolean",
  },
  {
    title: intl.formatMessage({ id: "created_on" }),
    field: "created_at",
    type: "date",
    defaultSort: "desc",
    headerStyle: { minWidth: 200 },
    render: ({ created_at, parentId }) =>
      parentId
        ? null
        : moment.utc(created_at).local().format("DD/MM/YYYY HH:mm:ss"),
  },
];

export const OPTIONS = {
  filtering: true,
  toolbar: false,
  sorting: true,
  emptyRowsWhenPaging: false,
  pageSizeOptions: [5, 10, 20, 50],
  headerStyle: {
    fontWeight: "bold",
    fontSize: 15,
    paddingTop: 8,
    paddingBottom: 8,
  },
  filterCellStyle: { paddingTop: 8, maxWidth: 200 },
  cellStyle: { textTransform: "uppercase" },
  rowStyle: (x) => {
    if (x.class === "Totale") {
      return { fontWeight: "bold" };
    }
  },
};

export const LOCALIZATION = {
  header: {
    actions: "",
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} di {count} righe",
    labelRowsSelect: "Righe",
  },
};
